import React, { Component, Fragment, forwardRef } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";

import { Row, Container, InputGroup } from "react-bootstrap";
import { years, months, isWeekday } from "../../utils/CalendarHelpers";
import { getMonth, getYear } from "date-fns";
import Header from "../App/Header/Header";
import OptimizedSearchResults from "../OptimizedSearch/OptimizedSearchResults/OptimizedSearchResults";
import "./OptimizedSearch.scss";

class OptimizedSearch extends Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(window.location.search);
    var query =
      queryParams.get("q") === null
        ? localStorage.getItem("_last_search_q")
        : queryParams.get("q");
    var filedAt =
      queryParams.get("filedAt") || localStorage.getItem("synced_date");

    this.state = {
      query: query,
      filedAt: filedAt || moment.utc().subtract(1, "days").format("YYYY-MM-DD"),
      filings: [],
    };
  }

  render() {
    const { query, filedAt } = this.state;

    return (
      <Fragment>
        <Header user={this.props.user} title={"Search"} />
        <Container className="MainContent Search">
          {/* <div className="sticky col-md-4">
              {this.renderSearchForm()}
            </div> */}
          <OptimizedSearchResults
            filedAt={filedAt}
            query={query}
            user={this.props.user}
            searchForm={this.renderSearchForm()}
          />
        </Container>
      </Fragment>
    );
  }
  setRefDate(date) {
    this.setState({ filedAt: moment(date).format("YYYY-MM-DD") }, () => {
      localStorage.setItem("filedAt", moment(date).format("YYYY-MM-DD"));
      this.props.history.push(
        `optimizedSearch?filedAt=${moment(date).format("YYYY-MM-DD")}`
      );
    });
  }

  renderSearchForm() {
    const { query, filedAt } = this.state;

    const DateInput = forwardRef(({ value, onClick }, ref) => (
      <button
        className="btn btn-success-deal-style px-2"
        style={{ borderRadius: "20px" }}
        onClick={onClick}
        ref={ref}
      >
        {value}
        <span className="material-icons">expand_more</span>
      </button>
    ));

    return (
      <>
        {/* <div className="float-left" style={{marginLeft: "1%", width: "25%", border: "2px solid yellow"}}> */}
        <div className="roundedEdges shadow">
          <DatePicker
            portalId="root-portal"
            filterDate={isWeekday}
            className="bg-gradient-success"
            dayClassName={() => {
              return "text-dark";
            }}
            onChange={(date) => {
              this.setRefDate(date);
            }}
            customInput={<DateInput />}
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  {" "}
                  {"<"}{" "}
                </button>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                >
                  {" "}
                  {">"}{" "}
                </button>
              </div>
            )}
            selected={moment(filedAt).toDate()}
          />
        </div>
        {/* <span className="col-xs-2" style={{marginLeft: '0.42%'}}>
                <SearchCriteria optimization={true} filedAt={filedAt} query={query} />
              </span> */}
        {/* </div> */}
      </>
    );
  }
}

OptimizedSearch.propTypes = {};

export default OptimizedSearch;
